// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-form-container {
  min-height: 100vh;
  background: var(--grey-shade-three);
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
}
@media (max-width: 768px) {
  .client-form-container {
    padding: 1rem;
  }
}
.client-form-container .client-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: client-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .client-form-container .client-form-wrapper {
    padding: 1rem;
    width: 95%;
  }
}
.client-form-container .client-form-header {
  position: relative;
  text-align: center;
  margin-bottom: 0.5rem;
}
.client-form-container .client-form-header .client-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .client-form-container .client-form-header .client-form-title {
    font-size: 1.25rem;
  }
}
.client-form-container .client-form-divider {
  border: none;
  border-top: 1px solid var(--grey-shade-two);
  margin: 1.5rem 0;
}
.client-form-container .client-form-content {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
}
.client-form-container .form-section {
  background: transparent;
  border-radius: 0.375rem;
  margin-bottom: 1.5rem;
}
.client-form-container .form-section.end-client {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .client-form-container .form-section {
    padding: 1rem;
  }
}
.client-form-container .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--grey-shade-two);
}
.client-form-container .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.client-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .client-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.client-form-container .form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.client-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.client-form-container .form-group label .clientform-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.client-form-container .form-group input,
.client-form-container .form-group select,
.client-form-container .form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.client-form-container .form-group input:focus,
.client-form-container .form-group select:focus,
.client-form-container .form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.client-form-container .form-group input:hover:not(:focus),
.client-form-container .form-group select:hover:not(:focus),
.client-form-container .form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.client-form-container .form-group input::placeholder,
.client-form-container .form-group select::placeholder,
.client-form-container .form-group textarea::placeholder {
  color: #9ca3af;
}
.client-form-container .form-group input:disabled,
.client-form-container .form-group select:disabled,
.client-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.client-form-container .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.client-form-container .form-group textarea {
  height: auto;
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.client-form-container .form-group .toggle-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
}
.client-form-container .form-group .toggle-container .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: pointer;
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox] {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox]:checked + .toggle-slider {
  background-color: #3b82f6;
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox]:checked + .toggle-slider:before {
  transform: translateX(26px);
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox]:focus + .toggle-slider {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.client-form-container .form-group .toggle-container .toggle-switch .toggle-slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--grey-main-bg);
  border-radius: 24px;
  transition: all 0.3s ease;
}
.client-form-container .form-group .toggle-container .toggle-switch .toggle-slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.client-form-container .form-group .toggle-container .toggle-switch:hover .toggle-slider {
  background-color: #9ca3af;
}
input:checked + .client-form-container .form-group .toggle-container .toggle-switch:hover .toggle-slider {
  background-color: #2563eb;
}
.client-form-container .form-group .toggle-container .toggle-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}
.client-form-container .form-group .toggle-description {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.375rem;
  font-style: italic;
  line-height: 1.4;
}
.client-form-container .case-selector-container {
  width: 100%;
}
.client-form-container .case-selector-multi {
  position: relative;
  width: 100%;
}
.client-form-container .case-selector-multi label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.client-form-container .case-selector-multi .dropdown-wrapper {
  position: relative;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  background: #ffffff;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .dropdown-wrapper:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.client-form-container .case-selector-multi .dropdown-wrapper:hover:not(:focus-within) {
  border-color: #9ca3af;
}
.client-form-container .case-selector-multi .search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.client-form-container .case-selector-multi .search-input-container .search-input {
  width: 100%;
  border: none;
  outline: none;
  padding: 0.5rem;
  font-size: 0.875rem;
  background: transparent;
  height: 2.5rem;
  box-sizing: border-box;
  color: #374151;
}
.client-form-container .case-selector-multi .search-input-container .search-input::placeholder {
  color: #9ca3af;
}
.client-form-container .case-selector-multi .search-input-container .dropdown-arrow {
  position: absolute;
  right: 0.5rem;
  color: #6b7280;
  pointer-events: none;
  transition: transform 0.2s ease;
}
.dropdown-wrapper:focus-within .client-form-container .case-selector-multi .search-input-container .dropdown-arrow {
  transform: rotate(180deg);
}
.client-form-container .case-selector-multi .selected-cases-container {
  padding: 0.75rem;
  border-top: 1px solid var(--grey-main-bg);
  min-height: 2rem;
  background: #f9fafb;
}
.client-form-container .case-selector-multi .selected-cases-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.client-form-container .case-selector-multi .court-section .court-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.client-form-container .case-selector-multi .court-section .cases-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}
.client-form-container .case-selector-multi .case-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .case-tag.high-court {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
}
.client-form-container .case-selector-multi .case-tag.high-court:hover {
  background-color: #fde68a;
}
.client-form-container .case-selector-multi .case-tag.district-court {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #3b82f6;
}
.client-form-container .case-selector-multi .case-tag.district-court:hover {
  background-color: #bfdbfe;
}
.client-form-container .case-selector-multi .case-tag.other-court {
  background-color: #f3e8ff;
  color: #7c3aed;
  border: 1px solid #8b5cf6;
}
.client-form-container .case-selector-multi .case-tag.other-court:hover {
  background-color: #e9d5ff;
}
.client-form-container .case-selector-multi .case-tag.supreme-court {
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #ef4444;
}
.client-form-container .case-selector-multi .case-tag.supreme-court:hover {
  background-color: #fecaca;
}
.client-form-container .case-selector-multi .case-tag .remove-btn {
  background: none;
  border: none;
  color: currentColor;
  cursor: pointer;
  font-size: 1rem;
  padding: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 0.7;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .case-tag .remove-btn:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.1);
}
.client-form-container .case-selector-multi .no-selection {
  color: #9ca3af;
  font-style: italic;
  font-size: 0.875rem;
  text-align: center;
  padding: 1rem;
}
.client-form-container .case-selector-multi .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.client-form-container .case-selector-multi .dropdown-header {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs {
  display: flex;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs .tab-btn {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs .tab-btn:hover {
  background: #f3f4f6;
  color: #374151;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs .tab-btn.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.client-form-container .case-selector-multi .dropdown-content {
  max-height: 250px;
  overflow-y: auto;
}
.client-form-container .case-selector-multi .dropdown-content .cases-list {
  padding: 0.25rem 0;
}
.client-form-container .case-selector-multi .dropdown-content .case-option {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .dropdown-content .case-option:hover {
  background: #f9fafb;
}
.client-form-container .case-selector-multi .dropdown-content .case-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.client-form-container .case-selector-multi .dropdown-content .case-option.selected .case-parties {
  font-weight: 600;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  line-height: 1.4;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  width: fit-content;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .selected-icon {
  color: #10b981;
  margin-left: 0.75rem;
  flex-shrink: 0;
}
.client-form-container .case-selector-multi .dropdown-content .loading-state,
.client-form-container .case-selector-multi .dropdown-content .no-results,
.client-form-container .case-selector-multi .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.client-form-container .case-selector-multi .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.client-form-container .case-selector-multi .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.client-form-container .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .client-form-container .form-actions {
    flex-direction: column;
  }
}
.client-form-container .form-actions .btn-primary {
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  border: none;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .client-form-container .form-actions .btn-primary {
    width: 100%;
  }
}
.client-form-container .form-actions .btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.client-form-container .form-actions .btn-primary {
  background-color: var(--primary-color);
  color: white;
}
.client-form-container .form-actions .btn-primary:hover {
  background-color: #005a9a;
}
.client-form-container .form-actions .btn-primary:focus {
  outline: none;
}
.client-form-container .form-actions .btn-primary:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.client-form-container .form-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.client-form-container .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}

.client-form-modal-container {
  min-height: auto;
  background-color: #fff;
  padding: 0rem;
}
.client-form-modal-container .client-form-modal-wrapper {
  background: #ffffff;
  border: none;
  border-radius: 0px;
  padding: 0rem;
  box-shadow: none;
  width: 100%;
}

@keyframes client-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar {
  width: 6px;
}

.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 1024px) {
  .client-form-container .client-form-wrapper {
    width: 85%;
  }
  .client-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
@media (max-width: 768px) {
  .client-form-container {
    padding: 1rem;
  }
  .client-form-container .client-form-wrapper {
    width: 95%;
  }
  .client-form-container .form-section {
    padding: 1rem;
  }
  .client-form-container .client-form-header .client-form-title {
    font-size: 1.25rem;
  }
  .client-form-container .form-section h3 {
    font-size: 1rem;
  }
  .client-form-container .case-selector-multi .dropdown-content {
    max-height: 200px;
  }
  .client-form-container .case-selector-multi .case-option {
    padding: 0.5rem 0.75rem;
  }
  .client-form-container .case-selector-multi .case-option .case-details .case-parties {
    font-size: 0.8125rem;
  }
  .client-form-container .case-selector-multi .case-tag {
    padding: 0.25rem 0.5rem;
    font-size: 0.6875rem;
  }
  .client-form-container .form-actions .btn-secondary,
  .client-form-container .form-actions .btn-primary {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media (max-width: 480px) {
  .client-form-container {
    padding: 0.5rem;
  }
  .client-form-container .client-form-wrapper {
    padding: 0.75rem;
    width: 100%;
  }
  .client-form-container .form-section {
    padding: 0.75rem;
  }
  .client-form-container .client-form-header .client-form-title {
    font-size: 1.125rem;
  }
  .client-form-container .form-group input,
  .client-form-container .form-group select,
  .client-form-container .form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .client-form-container {
    background: white;
    padding: 0;
  }
  .client-form-container .client-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .client-form-container .form-section {
    box-shadow: none;
    border: 1px solid #000;
    page-break-inside: avoid;
  }
  .client-form-container .form-actions,
  .client-form-container .dropdown-menu {
    display: none;
  }
  .client-form-container .case-tag .remove-btn {
    display: none;
  }
}
.client-form-container input:focus-visible,
.client-form-container select:focus-visible,
.client-form-container textarea:focus-visible,
.client-form-container button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.client-form-container .toggle-switch input:focus-visible + .toggle-slider {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/MyClientForm/MyClientForm.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EAXF;IAYI,aAAA;EACF;AACF;AAEE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,4CAAA;EACA,UAAA;AAAJ;AAEI;EATF;IAUI,aAAA;IACA,UAAA;EACJ;AACF;AAGE;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AADN;AAGM;EANF;IAOI,kBAAA;EAAN;AACF;AAKE;EACE,YAAA;EACA,2CAAA;EACA,gBAAA;AAHJ;AAOE;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;AALJ;AASE;EACE,uBAAA;EACA,uBAAA;EACA,qBAAA;AAPJ;AAUI;EACE,gBAAA;AARN;AAWI;EAVF;IAWI,aAAA;EARJ;AACF;AAUI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;AARN;AAaE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAXJ;AAaI;EACE,gBAAA;AAXN;AAcI;EATF;IAUI,sBAAA;IACA,WAAA;EAXJ;AACF;AAcE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAZJ;AAcI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAZN;AAaM;EACE,cAAA;EACA,oBAAA;AAXR;AAgBI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAdN;AAgBM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAZR;AAeM;;;EACE,qBAAA;AAXR;AAcM;;;EACE,cAAA;AAVR;AAaM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AATR;AAaI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAXN;AAcI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAZN;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAdN;AAgBM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAdR;AAgBQ;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAdV;AAgBU;EACE,yBAAA;AAdZ;AAgBY;EACE,2BAAA;AAdd;AAkBU;EACE,6CAAA;AAhBZ;AAoBQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;EACA,yBAAA;AAlBV;AAoBU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AAlBZ;AAsBQ;EACE,yBAAA;AApBV;AAsBU;EACE,yBAAA;AApBZ;AAyBM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAvBR;AA2BI;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAzBN;AA8BE;EACE,WAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,WAAA;AA7BJ;AA+BI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA7BN;AAgCI;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AA9BN;AAgCM;EACE,qBAAA;EACA,6CAAA;AA9BR;AAiCM;EACE,qBAAA;AA/BR;AAmCI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAjCN;AAmCM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AAjCR;AAmCQ;EACE,cAAA;AAjCV;AAqCM;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,+BAAA;AAnCR;AAqCQ;EACE,yBAAA;AAnCV;AAwCI;EACE,gBAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;AAtCN;AAyCI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAvCN;AA2CM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAzCR;AA4CM;EACE,aAAA;EACA,eAAA;EACA,aAAA;AA1CR;AA8CI;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA5CN;AA8CM;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA5CR;AA8CQ;EACE,yBAAA;AA5CV;AAgDM;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA9CR;AAgDQ;EACE,yBAAA;AA9CV;AAkDM;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAhDR;AAkDQ;EACE,yBAAA;AAhDV;AAoDM;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAlDR;AAoDQ;EACE,yBAAA;AAlDV;AAsDM;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AApDR;AAsDQ;EACE,UAAA;EACA,0CAAA;EACA,qBAAA;AApDV;AAyDI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAvDN;AA0DI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,qFAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAxDN;AA2DI;EACE,mBAAA;EACA,gCAAA;AAzDN;AA2DM;EACE,aAAA;AAzDR;AA2DQ;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AAzDV;AA2DU;EACE,mBAAA;EACA,cAAA;AAzDZ;AA4DU;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AA1DZ;AAgEI;EACE,iBAAA;EACA,gBAAA;AA9DN;AAgEM;EACE,kBAAA;AA9DR;AAiEM;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AA/DR;AAiEQ;EACE,mBAAA;AA/DV;AAkEQ;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAhEV;AAkEU;EACE,gBAAA;AAhEZ;AAoEQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAlEV;AAoEU;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAlEZ;AAqEU;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AAnEZ;AAsEU;EACE,kBAAA;EACA,cAAA;AApEZ;AAwEQ;EACE,cAAA;EACA,oBAAA;EACA,cAAA;AAtEV;AA0EM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAxER;AA2EM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAzER;AA2EQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAzEV;AAgFE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AA9EJ;AAgFI;EARF;IASI,sBAAA;EA7EJ;AACF;AA+EI;EACE,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AA7EN;AA+EM;EAVF;IAWI,WAAA;EA5EN;AACF;AA8EM;EACE,YAAA;EACA,mBAAA;AA5ER;AA8FI;EACE,sCAAA;EACA,YAAA;AA5FN;AA8FM;EACE,yBAAA;AA5FR;AA8FM;EACE,aAAA;AA5FR;AA+FM;EACE,yBAAA;EACA,cAAA;AA7FR;AAgGI;EACE,iBAAA;EACF,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA9FJ;AAgGI;EACE,yBAAA;AA9FN;;AAoGA;EACE,gBAAA;EACA,sBAAA;EACA,aAAA;AAjGF;AAmGE;EACG,mBAAA;EACD,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AAjGJ;;AAsGA;EACE;IACE,UAAA;IACA,2BAAA;EAnGF;EAqGA;IACE,UAAA;IACA,wBAAA;EAnGF;AACF;AAsGA;EACE;IACE,UAAA;IACA,2BAAA;EApGF;EAsGA;IACE,UAAA;IACA,wBAAA;EApGF;AACF;AAuGA;EACE;IACE,uBAAA;EArGF;EAuGA;IACE,yBAAA;EArGF;AACF;AAyGA;EACE,UAAA;AAvGF;;AA0GA;EACE,mBAAA;EACA,kBAAA;AAvGF;;AA0GA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAvGF;;AA0GA;EACE,mBAAA;AAvGF;;AA2GA;EAEI;IACE,UAAA;EAzGJ;EA4GE;IACE,sBAAA;IACA,WAAA;EA1GJ;AACF;AA8GA;EACE;IACE,aAAA;EA5GF;EA8GE;IACE,UAAA;EA5GJ;EA+GE;IACE,aAAA;EA7GJ;EAgHE;IACE,kBAAA;EA9GJ;EAiHE;IACE,eAAA;EA/GJ;EAmHI;IACE,iBAAA;EAjHN;EAoHI;IACE,uBAAA;EAlHN;EAqHQ;IACE,oBAAA;EAnHV;EAwHI;IACE,uBAAA;IACA,oBAAA;EAtHN;EA2HI;;IAEE,oBAAA;IACA,oBAAA;EAzHN;AACF;AA8HA;EACE;IACE,eAAA;EA5HF;EA8HE;IACE,gBAAA;IACA,WAAA;EA5HJ;EA+HE;IACE,gBAAA;EA7HJ;EAgIE;IACE,mBAAA;EA9HJ;EAkII;;;IAGE,iBAAA;IACA,oBAAA;EAhIN;AACF;AAsIA;EACE;IACE,iBAAA;IACA,UAAA;EApIF;EAsIE;IACE,gBAAA;IACA,sBAAA;EApIJ;EAuIE;IACE,gBAAA;IACA,sBAAA;IACA,wBAAA;EArIJ;EAwIE;;IAEE,aAAA;EAtIJ;EAyIE;IACE,aAAA;EAvIJ;AACF;AA6IE;;;;EAIE,0BAAA;EACA,mBAAA;AA3IJ;AA8IE;EACE,0BAAA;EACA,mBAAA;AA5IJ","sourcesContent":["// Main Container - Match HighCourtCaseForm styling\r\n.client-form-container {\r\n  min-height: 100vh;\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n  // Form Content Wrapper (to match LabelForm card style)\r\n  .client-form-wrapper {\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    animation: client-form-fade-in 0.3s ease-out;\r\n    width: 70%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      width: 95%;\r\n    }\r\n  }\r\n\r\n  // Header styling (similar to LabelForm)\r\n  .client-form-header {\r\n    position: relative;\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n    .client-form-title {\r\n      font-size: 1.3rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Divider styling (match LabelForm)\r\n  .client-form-divider {\r\n    border: none;\r\n    border-top: 1px solid var(--grey-shade-two);\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n  // Form content styling\r\n  .client-form-content {\r\n    padding: 0;\r\n    margin: 0;\r\n    border: none;\r\n    background: transparent;\r\n  }\r\n\r\n  // Form structure styling\r\n  .form-section {\r\n    background: transparent;\r\n    border-radius: 0.375rem;\r\n    margin-bottom: 1.5rem;\r\n    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n\r\n    &.end-client {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid var(--grey-shade-two);\r\n    }\r\n  }\r\n\r\n  // Form rows and groups\r\n  .form-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n\r\n  .form-group {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n      .clientform-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n    // Input styling to match HighCourtCaseForm\r\n    input,\r\n    select,\r\n    textarea {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      height: 2.5rem;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #f9fafb;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    select {\r\n      appearance: none;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 0.5rem center;\r\n      background-repeat: no-repeat;\r\n      background-size: 1.5rem 1.5rem;\r\n      padding-right: 2.5rem;\r\n    }\r\n\r\n    textarea {\r\n      height: auto;\r\n      min-height: 4rem;\r\n      resize: vertical;\r\n      line-height: 1.5;\r\n    }\r\n\r\n    // Toggle switch styles\r\n    .toggle-container {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.75rem;\r\n      margin-top: 0.5rem;\r\n\r\n      .toggle-switch {\r\n        position: relative;\r\n        width: 50px;\r\n        height: 24px;\r\n        cursor: pointer;\r\n\r\n        input[type=\"checkbox\"] {\r\n          opacity: 0;\r\n          position: absolute;\r\n          width: 0;\r\n          height: 0;\r\n\r\n          &:checked + .toggle-slider {\r\n            background-color: #3b82f6;\r\n            \r\n            &:before {\r\n              transform: translateX(26px);\r\n            }\r\n          }\r\n\r\n          &:focus + .toggle-slider {\r\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n          }\r\n        }\r\n\r\n        .toggle-slider {\r\n          position: absolute;\r\n          top: 0;\r\n          left: 0;\r\n          right: 0;\r\n          bottom: 0;\r\n          background-color: var(--grey-main-bg);\r\n          border-radius: 24px;\r\n          transition: all 0.3s ease;\r\n\r\n          &:before {\r\n            content: '';\r\n            position: absolute;\r\n            height: 18px;\r\n            width: 18px;\r\n            left: 3px;\r\n            top: 3px;\r\n            background-color: white;\r\n            border-radius: 50%;\r\n            transition: all 0.3s ease;\r\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n          }\r\n        }\r\n\r\n        &:hover .toggle-slider {\r\n          background-color: #9ca3af;\r\n\r\n          input:checked + & {\r\n            background-color: #2563eb;\r\n          }\r\n        }\r\n      }\r\n\r\n      .toggle-label {\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        color: #374151;\r\n      }\r\n    }\r\n\r\n    .toggle-description {\r\n      font-size: 0.75rem;\r\n      color: #6b7280;\r\n      margin-top: 0.375rem;\r\n      font-style: italic;\r\n      line-height: 1.4;\r\n    }\r\n  }\r\n\r\n  // Case selector styles - Enhanced to match HighCourtCaseForm\r\n  .case-selector-container {\r\n    width: 100%;\r\n  }\r\n\r\n  .case-selector-multi {\r\n    position: relative;\r\n    width: 100%;\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n    }\r\n\r\n    .dropdown-wrapper {\r\n      position: relative;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      background: #ffffff;\r\n      transition: all 0.2s ease;\r\n\r\n      &:focus-within {\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus-within) {\r\n        border-color: #9ca3af;\r\n      }\r\n    }\r\n\r\n    .search-input-container {\r\n      position: relative;\r\n      display: flex;\r\n      align-items: center;\r\n\r\n      .search-input {\r\n        width: 100%;\r\n        border: none;\r\n        outline: none;\r\n        padding: 0.5rem;\r\n        font-size: 0.875rem;\r\n        background: transparent;\r\n        height: 2.5rem;\r\n        box-sizing: border-box;\r\n        color: #374151;\r\n\r\n        &::placeholder {\r\n          color: #9ca3af;\r\n        }\r\n      }\r\n\r\n      .dropdown-arrow {\r\n        position: absolute;\r\n        right: 0.5rem;\r\n        color: #6b7280;\r\n        pointer-events: none;\r\n        transition: transform 0.2s ease;\r\n\r\n        .dropdown-wrapper:focus-within & {\r\n          transform: rotate(180deg);\r\n        }\r\n      }\r\n    }\r\n\r\n    .selected-cases-container {\r\n      padding: 0.75rem;\r\n      border-top: 1px solid var(--grey-main-bg);\r\n      min-height: 2rem;\r\n      background: #f9fafb;\r\n    }\r\n\r\n    .selected-cases-grid {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 0.75rem;\r\n    }\r\n\r\n    .court-section {\r\n      .court-label {\r\n        font-size: 0.75rem;\r\n        font-weight: 600;\r\n        color: #6b7280;\r\n        margin-bottom: 0.5rem;\r\n        text-transform: uppercase;\r\n        letter-spacing: 0.025em;\r\n      }\r\n\r\n      .cases-tags {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        gap: 0.375rem;\r\n      }\r\n    }\r\n\r\n    .case-tag {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      gap: 0.375rem;\r\n      padding: 0.375rem 0.75rem;\r\n      border-radius: 1rem;\r\n      font-size: 0.75rem;\r\n      font-weight: 500;\r\n      transition: all 0.2s ease;\r\n\r\n      &.high-court {\r\n        background-color: #fef3c7;\r\n        color: #92400e;\r\n        border: 1px solid #f59e0b;\r\n\r\n        &:hover {\r\n          background-color: #fde68a;\r\n        }\r\n      }\r\n\r\n      &.district-court {\r\n        background-color: #dbeafe;\r\n        color: #1e40af;\r\n        border: 1px solid #3b82f6;\r\n\r\n        &:hover {\r\n          background-color: #bfdbfe;\r\n        }\r\n      }\r\n\r\n      &.other-court {\r\n        background-color: #f3e8ff;\r\n        color: #7c3aed;\r\n        border: 1px solid #8b5cf6;\r\n\r\n        &:hover {\r\n          background-color: #e9d5ff;\r\n        }\r\n      }\r\n\r\n      &.supreme-court {\r\n        background-color: #fee2e2;\r\n        color: #991b1b;\r\n        border: 1px solid #ef4444;\r\n\r\n        &:hover {\r\n          background-color: #fecaca;\r\n        }\r\n      }\r\n\r\n      .remove-btn {\r\n        background: none;\r\n        border: none;\r\n        color: currentColor;\r\n        cursor: pointer;\r\n        font-size: 1rem;\r\n        padding: 0;\r\n        width: 18px;\r\n        height: 18px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 50%;\r\n        opacity: 0.7;\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover {\r\n          opacity: 1;\r\n          background-color: rgba(255, 255, 255, 0.6);\r\n          transform: scale(1.1);\r\n        }\r\n      }\r\n    }\r\n\r\n    .no-selection {\r\n      color: #9ca3af;\r\n      font-style: italic;\r\n      font-size: 0.875rem;\r\n      text-align: center;\r\n      padding: 1rem;\r\n    }\r\n\r\n    .dropdown-menu {\r\n      position: absolute;\r\n      top: 100%;\r\n      left: 0;\r\n      right: 0;\r\n      z-index: 1000;\r\n      background: #ffffff;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.375rem;\r\n      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n      margin-top: 0.25rem;\r\n      overflow: hidden;\r\n      animation: dropdown-fade-in 0.2s ease-out;\r\n    }\r\n\r\n    .dropdown-header {\r\n      background: #f9fafb;\r\n      border-bottom: 1px solid #e5e7eb;\r\n\r\n      .court-tabs {\r\n        display: flex;\r\n\r\n        .tab-btn {\r\n          flex: 1;\r\n          padding: 0.75rem 1rem;\r\n          border: none;\r\n          background: transparent;\r\n          color: #6b7280;\r\n          font-weight: 500;\r\n          font-size: 0.875rem;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n          border-bottom: 2px solid transparent;\r\n\r\n          &:hover {\r\n            background: #f3f4f6;\r\n            color: #374151;\r\n          }\r\n\r\n          &.active {\r\n            background: #ffffff;\r\n            color: #3b82f6;\r\n            font-weight: 600;\r\n            border-bottom-color: #3b82f6;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .dropdown-content {\r\n      max-height: 250px;\r\n      overflow-y: auto;\r\n\r\n      .cases-list {\r\n        padding: 0.25rem 0;\r\n      }\r\n\r\n      .case-option {\r\n        display: flex;\r\n        align-items: center;\r\n        padding: 0.75rem 1rem;\r\n        cursor: pointer;\r\n        border-bottom: 1px solid #f3f4f6;\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover {\r\n          background: #f9fafb;\r\n        }\r\n\r\n        &.selected {\r\n          background: #eff6ff;\r\n          color: #1e40af;\r\n          border-left: 3px solid #3b82f6;\r\n\r\n          .case-parties {\r\n            font-weight: 600;\r\n          }\r\n        }\r\n\r\n        .case-details {\r\n          flex: 1;\r\n          display: flex;\r\n          flex-direction: column;\r\n          gap: 0.25rem;\r\n\r\n          .case-parties {\r\n            font-weight: 500;\r\n            color: #374151;\r\n            font-size: 0.875rem;\r\n            line-height: 1.4;\r\n          }\r\n\r\n          .case-ref {\r\n            font-size: 0.75rem;\r\n            color: #6b7280;\r\n            background: #f3f4f6;\r\n            padding: 0.125rem 0.375rem;\r\n            border-radius: 0.25rem;\r\n            display: inline-block;\r\n            width: fit-content;\r\n          }\r\n\r\n          .case-number {\r\n            font-size: 0.75rem;\r\n            color: #9ca3af;\r\n          }\r\n        }\r\n\r\n        .selected-icon {\r\n          color: #10b981;\r\n          margin-left: 0.75rem;\r\n          flex-shrink: 0;\r\n        }\r\n      }\r\n\r\n      .loading-state,\r\n      .no-results,\r\n      .empty-state {\r\n        padding: 2rem 1rem;\r\n        text-align: center;\r\n        color: #6b7280;\r\n        font-style: italic;\r\n        font-size: 0.875rem;\r\n      }\r\n\r\n      .loading-state {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 0.5rem;\r\n\r\n        &::before {\r\n          content: '';\r\n          width: 16px;\r\n          height: 16px;\r\n          border: 2px solid #e5e7eb;\r\n          border-top: 2px solid #3b82f6;\r\n          border-radius: 50%;\r\n          animation: spin 1s linear infinite;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Form actions to match HighCourtCaseForm\r\n  .form-actions {\r\n    display: flex;\r\n    justify-content: end;\r\n    gap: 1rem;\r\n    margin-top: 1.5rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n    }\r\n\r\n    .btn-primary {\r\n      padding: 0.75rem 1.5rem;\r\n      border-radius: 0.25rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      cursor: pointer;\r\n      border: none;\r\n      min-width: 120px;\r\n      transition: all 0.2s ease;\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n      }\r\n\r\n      &:disabled {\r\n        opacity: 0.6;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    // .btn-secondary {\r\n    //   background-color: #dc2626;\r\n    //   color: white;\r\n\r\n    //   &:hover:not(:disabled) {\r\n    //     background-color: #b91c1c;\r\n    //   }\r\n\r\n    //   &:focus {\r\n    //     outline: none;\r\n    //     box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\r\n    //   }\r\n    // }\r\n\r\n    .btn-primary {\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n\r\n      &:hover{\r\n        background-color: #005a9a;\r\n      }\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #d1d5db;\r\n        color: #9ca3af;\r\n      }\r\n    }\r\n    .btn-cancel{\r\n      padding: 8px 16px;\r\n    border: 1px solid #ddd;\r\n    background: white;\r\n    color: #666;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n\r\n    &:hover {\r\n      background-color: #f8f9fa;\r\n    }\r\n    }\r\n  }\r\n}\r\n\r\n.client-form-modal-container{\r\n  min-height: auto;\r\n  background-color: #fff;\r\n  padding: 0rem;\r\n\r\n  .client-form-modal-wrapper{\r\n     background: #ffffff;\r\n    border: none;\r\n    border-radius: 0px;\r\n    padding: 0rem;\r\n    box-shadow: none;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes client-form-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes dropdown-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n// Scrollbar styling for dropdown\r\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 3px;\r\n}\r\n\r\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n// Responsive design improvements\r\n@media (max-width: 1024px) {\r\n  .client-form-container {\r\n    .client-form-wrapper {\r\n      width: 85%;\r\n    }\r\n\r\n    .form-row {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .client-form-container {\r\n    padding: 1rem;\r\n\r\n    .client-form-wrapper {\r\n      width: 95%;\r\n    }\r\n\r\n    .form-section {\r\n      padding: 1rem;\r\n    }\r\n\r\n    .client-form-header .client-form-title {\r\n      font-size: 1.25rem;\r\n    }\r\n\r\n    .form-section h3 {\r\n      font-size: 1rem;\r\n    }\r\n\r\n    .case-selector-multi {\r\n      .dropdown-content {\r\n        max-height: 200px;\r\n      }\r\n\r\n      .case-option {\r\n        padding: 0.5rem 0.75rem;\r\n\r\n        .case-details {\r\n          .case-parties {\r\n            font-size: 0.8125rem;\r\n          }\r\n        }\r\n      }\r\n\r\n      .case-tag {\r\n        padding: 0.25rem 0.5rem;\r\n        font-size: 0.6875rem;\r\n      }\r\n    }\r\n\r\n    .form-actions {\r\n      .btn-secondary,\r\n      .btn-primary {\r\n        padding: 0.5rem 1rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .client-form-container {\r\n    padding: 0.5rem;\r\n\r\n    .client-form-wrapper {\r\n      padding: 0.75rem;\r\n      width: 100%;\r\n    }\r\n\r\n    .form-section {\r\n      padding: 0.75rem;\r\n    }\r\n\r\n    .client-form-header .client-form-title {\r\n      font-size: 1.125rem;\r\n    }\r\n\r\n    .form-group {\r\n      input,\r\n      select,\r\n      textarea {\r\n        padding: 0.375rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .client-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    .client-form-wrapper {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .form-section {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    .form-actions,\r\n    .dropdown-menu {\r\n      display: none;\r\n    }\r\n\r\n    .case-tag .remove-btn {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Focus visible improvements for accessibility\r\n.client-form-container {\r\n  input:focus-visible,\r\n  select:focus-visible,\r\n  textarea:focus-visible,\r\n  button:focus-visible {\r\n    outline: 2px solid #3b82f6;\r\n    outline-offset: 2px;\r\n  }\r\n\r\n  .toggle-switch input:focus-visible + .toggle-slider {\r\n    outline: 2px solid #3b82f6;\r\n    outline-offset: 2px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
